/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section4_P1Inputs */

const en_terms_section4_p1 = /** @type {(inputs: Terms_Section4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is provided "as is" and "as available" without any warranties of any kind, express or implied. We do not guarantee that the service will be uninterrupted, error-free, or that the results produced by the tools will be accurate.`)
};

const ko_terms_section4_p1 = /** @type {(inputs: Terms_Section4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 명시적이든 묵시적이든 어떠한 종류의 보증 없이 "있는 그대로" 제공됩니다. 서비스가 중단 없이 오류 없이 제공되거나 도구가 생성한 결과가 정확하다는 것을 보장하지 않습니다.`)
};

const ja_terms_section4_p1 = /** @type {(inputs: Terms_Section4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONは、明示的か黙示的かを問わず、いかなる種類の保証もなく「現状のまま」提供されます。サービスが中断なく、エラーなく提供されること、またはツールが生成した結果が正確であることを保証するものではありません。`)
};

/**
* | output |
* | --- |
* | "PureJSON is provided \"as is\" and \"as available\" without any warranties of any kind, express or implied. We do not guarantee that the service will be uninterr..." |
*
* @param {Terms_Section4_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section4_p1 = /** @type {((inputs?: Terms_Section4_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section4_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section4_p1(inputs)
	if (locale === "ko") return ko_terms_section4_p1(inputs)
	return ja_terms_section4_p1(inputs)
});